<div class="mat-dialog-wrapper">
    <div class="d-flex justify-space-between align-items-center mb-1">
      <h2 mat-dialog-title class="mb-10">Submit Accounts</h2>
      <button
        type="button"
        mat-button
        disableRipple
        mat-dialog-close
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="d-flex align-items-center gap-10 mb-1">
      <span class="fw-bold">Period: </span>
      <mat-form-field class="w-200">
        <mat-select
          panelClass="mat-select-position"
          [disableOptionCentering]="true"
          [(ngModel)]="accountingId"
          (selectionChange)="onPeriodChange()"
        >
          <mat-option
            *ngFor="let option of periodicDateList"
            [value]="option.id"
            title="{{ option.fromDate | date: 'dd-LLL-yyyy' }} - {{
              option.toDate | date: 'dd-LLL-yyyy'
            }}"
          >
            {{ option.fromDate | date: "dd-LLL-yyyy" }} -
            {{ option.toDate | date: "dd-LLL-yyyy" }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <mat-dialog-content>
      <div class="mat-table-wrapper" [ngClass]="{ 'mat-table-wrapper-noData': noDataFound }">
        <table
          mat-table
          [dataSource]="annualReportListSavedFiles"
          aria-describedby="Validate Report Table"
        >
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef class="w-80">S.No</th>
            <td mat-cell *matCellDef="let element;let i=index">
              <div class="d-flex align-items-center">
                <mat-radio-button  [checked]="(i === 0)" [value]="element.id" (change)="radioChange($event)"></mat-radio-button>
                <div class="white-space-nowrap spce">{{ element.srno }}</div>
              </div>              
            </td>
          </ng-container>
          <ng-container matColumnDef="period">
            <th mat-header-cell *matHeaderCellDef class="w-150">Period</th>
            <td mat-cell *matCellDef="let element">
                <div class="white-space-nowrap">{{ element.period }}</div>
            </td>
          </ng-container>
          <!-- <ng-container matColumnDef="desc">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let element">
              <div class="d-flex">
                <div class="onelineclamp" title="{{ element.desc }}">{{ element.desc }}</div>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef class="w-80">Type</th>
            <td mat-cell *matCellDef="let element">
                <div class="white-space-nowrap">{{ element.type }}</div>
            </td>
          </ng-container> -->
          <tr mat-header-row *matHeaderRowDef="displayedAccountColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedAccountColumns"></tr>
        </table>

        <div *ngIf="noDataFound" class="text-align-center mt-1">
          No records found
        </div>
    </div>
    <div class="d-flex justify-content-center pb-5 pt-10 hr-top pt-1 mt-5">
      <button
        class="action-button primary-button mr-1"
        type="button"
        mat-button
        disableRipple
        mat-dialog-close
        (click)="redirectToSubmit()"
      >
        Submit
      </button>
      <button
        class="action-button secondary-button"
        mat-dialog-close
        disableRipple
        type="button"
        mat-button
        disableRipple
      >
        Cancel
      </button>
    </div>
    </mat-dialog-content>
</div>
  
  <app-custom-notifications></app-custom-notifications>
  